import React from "react";

function Profile() {
  return <div>WElcome to profile</div>;
}

export default Profile;
